/**
 * Layout max-width helpers (not MUI breakpoints).
 * @see docs/DESIGN_SYSTEM.md §6
 */

/** @type {Record<string, string>} */
export const LEGACY_LAYOUT_MAP = {
  tcal: "calendar",
  tbill: "billing",
  tc: "container",
  tp: "pageTablet",
  bp: "booking",
  cplc: "packageList",
  caf: "appointmentForm",
  ntc: "content",
  invoice_container: "invoice",
  posts_container: "posts",
  editorjs_container: "editor",
  invoice_form: "invoiceForm",
  client_portal: "clientPortal",
};

export const LEGACY_LAYOUT_KEYS = Object.keys(LEGACY_LAYOUT_MAP);

/**
 * @param {string} keyOrLegacy
 * @returns {string}
 */
export function resolveLayoutKey(keyOrLegacy) {
  return LEGACY_LAYOUT_MAP[keyOrLegacy] || keyOrLegacy;
}

/**
 * @param {import('@mui/material/styles').Theme} theme
 * @param {string} keyOrLegacy
 * @returns {number|undefined}
 */
export function getLayoutMaxWidth(theme, keyOrLegacy) {
  const key = resolveLayoutKey(keyOrLegacy);
  return theme.treffas?.layout?.[key];
}

/**
 * @param {import('@mui/material/styles').Theme} theme
 * @param {string} keyOrLegacy
 */
export function layoutContainerSx(theme, keyOrLegacy) {
  return {
    maxWidth: getLayoutMaxWidth(theme, keyOrLegacy),
    width: "100%",
  };
}
